// removed by extract-text-webpack-plugin
module.exports = {"main":"QCOZFfAPaTtuJOqS3UtbX","content":"_3Yppz0UDmn5LbQBUpIBh","github-outer-wrapper":"_3S_J8dBo6K7KYccrVbZj_G"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/main.module.styl
// module id = 250
// module chunks = 79611799117203 210842664985301